import './PresiCardSecond.scss';

const PresiCardSecond = ({ party, isMobile }) => {
  const styleBorder = isMobile ? { borderRight: `1.2px solid ${party.color}` } : {};
  let cantCandidates = party.candidates.length;

  return (
    <div className="p-card-second">
      <div className="p-card-second__images-ctn">
        <div className="images">
          {party.candidates.map((e) => (
            <img key={e.fullname} loading="lazy" src={e.avatar} alt="president img" />
          ))}
        </div>
        <div className="bar" style={{ backgroundColor: party.color }}></div>
      </div>
      <div className="p-card-second__data">
        <div className="p-card-second__data-candidates" style={styleBorder}>
          {party.candidates.map((e) => (
            <div key={e.fullname} className="info-ctn info-ctn-center">
              {cantCandidates > 1 && (
                <p
                  className={cantCandidates <= 1 ? 'info-ctn__position' : 'info-ctn__position-two'}
                  style={{ color: party.color }}
                >
                  {e.candidate_id}
                </p>
              )}
              <p className={cantCandidates <= 1 ? 'info-ctn__name' : 'info-ctn__name-two'}>{e.fullname}</p>
            </div>
          ))}
        </div>
        {!isMobile && <div className="p-card-second__data-divider" style={{ borderBottomColor: party.color }}></div>}
        <div className="p-card-second__data-party">
          <p className="p-card-second__data-party__name" style={{ color: party.color }}>
            {party.name}
          </p>
          <p className="p-card-second__data-party__votes-percent" style={{ color: party.color }}>
            {party.votes_percent.toFixed(2).toString().replace('.', ',')}%
          </p>
          <p className="p-card-second__data-party__votes">{party.votes} votos</p>
        </div>
      </div>
    </div>
  );
};

export default PresiCardSecond;
